import Image from 'next/image';
import styles from './nft-intro.module.css';
import rocket from '../../public/nft/intro/rocket.png';
import { Button, Container } from '../../components';

export default function NFTIntro() {
  return (
    <section className={styles.section}>
      <Container variant="container_medium">
        <div className={styles.inner}>
          <div className={styles.start}>
            <h1 className={styles.title}>
              How to Build an NFT Marketplace and Ride the Wave
            </h1>
            <div className={styles.block}>
              <p className={styles.text}>
                If you&apos;re asking this question, you might know how popular
                the Decentralization trend is getting nowadays. But let us talk
                more about numbers and details. The development of blockchain
                technology is progressively enveloping our lives. Such areas as
                decentralized finance (DeFi), cryptocurrencies and non-fungible
                tokens (NFTs) are increasingly attracting interest. As for the
                NFT, the annual growth of market capitalization alone for 2022
                grew by 138% and this is not the limit. We invite you to join
                the trend of NFT marketplaces and ride this wave with us.
              </p>
              <Button tag="a" href="/contact" appearance="nft">
                Get a consultation
              </Button>
            </div>
          </div>

          <div className={styles.end}>
            <Image
              alt="Rocket picture"
              src={rocket}
              placeholder="blur"
              quality={100}
              width={769}
              height={763}
            />
          </div>
        </div>
      </Container>
    </section>
  );
}
